import React from "react";

export const Cargando = ({ cargando = false, texto = "Cargando datos..." }) => {
  return (
    <div
      style={{
        zIndex: 9999,
        display: cargando ? "none" : "block",
        position: "fixed",
        height: "100%",
        width: "100%",
        background: "rgba(0, 0, 0, 0.75)",
        textAlign: "center",
      }}
    >
      <h1 style={{ marginTop: "45vh", color: "#FFF" }}>{texto}</h1>
    </div>
  );
};
